import PropTypes from 'prop-types';
import React, { Suspense, useEffect } from 'react';
import PWAPrompt from 'react-ios-pwa-prompt';
import routes from 'src/routes';
import { useNavigate, useLocation, useRoutes } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import Topbar from './Topbar';
import {  setIpAddress, setSessionToken, setUserSession } from 'src/utils/Common';
import axios2 from 'axios';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: (theme) => ({
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    paddingTop: '64px',
    [theme.breakpoints.down('xs')]: {
      paddingTop: '10px'
    }
  })
};

function Auth() {
  const [Loading, setLoading] = React.useState(true);
  const [Error, setError] = React.useState(null);
  var options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };
  const navigate = useNavigate();
  const location = useLocation();
  const routesElement = useRoutes(routes);
  const { oktaAuth, authState } = useOktaAuth();

  navigator.geolocation.getCurrentPosition(success, error, options);
  function success(pos) {
    // var crd = pos.coords;
  }

  function error(err) {
  }
  const SaveLocal = async (UserId, AuthToken, ServiceShopCode, ServiceShopId, TechnicianId) => {
   // SaveLocalInvoiceAddress(UserId, AuthToken, ServiceShopCode, ServiceShopId, TechnicianId);
  };

  useEffect(() => {
    if (authState === null) {
      const fromUri = location.pathname + location.search;
      oktaAuth.signInWithRedirect(fromUri);
    }
    if (authState !== null && authState.isAuthenticated) {
      oktaAuth.getUser().then(info => {
        if (info === undefined) {
          const fromUri = location.pathname + location.search;
          oktaAuth.signInWithRedirect(fromUri);
        }
        const UserNames = info?.preferred_username.split("@");
        const dataUser = [{
          // UserName: UserNames[0],
          TerminalId: '1',
          VersionNr: process.env.REACT_APP_VERSION,
          TerminalIp:'1',
          LanguageId: '1'
        }];
        const configUser = {
          headers: {
            'Content-Type': 'application/json'
            , 'IpAddress': 1
            , 'accessToken': authState.accessToken.accessToken
            , 'Authorization': 'Bearer ' + authState.accessToken.accessToken
          }
        };

        let Address = process.env.REACT_APP_API_URL + "/GetUser";
        axios2.post(Address, dataUser, configUser)
          .then((response) => {
            setSessionToken(authState.accessToken.accessToken, response.data[0].SessionTokenWs || '');
            setIpAddress(1);
            setUserSession(authState.accessToken.accessToken, response.data[0].SessionTokenWs || '', response.data[0]);
            setLoading(false);
            SaveLocal(response.data[0].UserId, authState.accessToken.accessToken,
              response.data[0].ServiceShopCode, response.data[0].ServiceShopId,
              response.data[0].TechnicianId);
            SaveMenu(response.data[0].UserId, response.data[0].SessionTokenWs);
            setLoading(false);
            if (response.data[0].Role_Id === 10 && !sessionStorage.getItem('reloadedOnce')) {
              sessionStorage.setItem('reloadedOnce', 'true');
              window.location.reload();
            }
            navigate('/profile/1/timeline');
          }).catch((error) => {
            setError("Kullanıcı Adı ve Parolanızı kontrol ediniz!...");
            setLoading(false);
            navigate('/Unauthorized');
          });
      });
    }
    if (authState !== null && !authState.isAuthenticated) {
      const fromUri = location.pathname + location.search;
      oktaAuth.signInWithRedirect(fromUri);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const SaveMenu = async (UserId, AuthToken) => {
    const dataMenu = [{
      UserName: UserId
    }];
    const configMenu = {
      headers: {
        'Content-Type': 'application/json'
        , 'IpAddress': 1
        , 'SessionToken': AuthToken
        , 'accessToken': authState.accessToken.accessToken
        , 'Authorization': 'Bearer ' + authState.accessToken.accessToken

      }
    };
    let AddressMenu = process.env.REACT_APP_API_URL + "/GetUserMenu";
    axios2.post(AddressMenu, dataMenu, configMenu)
      .then((response) => {
        const MenuData = response.data.length === 0 ? [] : response.data;
        sessionStorage.removeItem('MenuData');
        sessionStorage.setItem('MenuData', JSON.stringify(MenuData));
        localStorage.removeItem('MenuData');
        localStorage.setItem('MenuData', JSON.stringify(MenuData));
        navigate('/profile/1/timeline');
      }).catch((error) => {
        setError("Yetkiniz bulunmuyor.Lütfen yetkilerinizi tanımlatınız!...");
        setLoading(false);
      });

      let ComboUrl = process.env.REACT_APP_API_URL + "/GetHavcComboValues";
      axios2.post(ComboUrl, dataMenu, configMenu)
        .then((response) => {
          const HavcData = response.data.length === 0 ? [] : response.data;
          localStorage.removeItem('HavcComboData')
          localStorage.setItem('HavcComboData', JSON.stringify(HavcData));
        }).catch((error) => {
          setError("Yetkiniz bulunmuyor.Lütfen yetkilerinizi tanımlatınız!...");
          setLoading(false);
        });      
  };

  return (
    <>
      <Topbar />
      <Box sx={styles.container}>
        <Box sx={styles.content}>
          {Loading &&
          <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: '100vh' }}
      >
          <Typography component="h2" gutterBottom variant="overline">
              Yönlendiriliyorsunuz
          </Typography>
          <CircularProgress disableShrink />
      </Grid>
          
          }
          <PWAPrompt
            promptOnVisit={1}
            timesToShow={3}
            copyTitle={'Ana Ekrana Ekle'}
            copyBody={
              'Mobil cihazınızın tarayıcısı üzerinden erişebileceğiniz Apollo uygulaması kolayca indirilebilir ve cihazınızda yer kaplamaz.'
            }
            copyShareButtonLabel={
              "1) Alt tarafta bulunan 'Paylaş' ikonuna dokunun"
            }
            copyAddHomeButtonLabel={
              "2) Açılan menüde bulunan 'Ana Ekrana Ekle'ye tıklayın"
            }
            copyClosePrompt={'Kapat'}
            permanentlyHideOnDismiss={false}
          />
          <Suspense fallback={null}>
            {routesElement}
          </Suspense>
        </Box>
      </Box>
    </>
  );
}

Auth.propTypes = {
  route: PropTypes.object
};

export default Auth;
